import WaterMarkLogo from "../assets/img/AaysLogo.png";
import favicon from "../assets/img/favicon.png";
import sidebarCollapsedLogo from "../assets/img/aaysfooter_logo.png";
import sidebarExpandedLogo from "../assets/img/Aays.png";

const uiConfig = {
  // Sidebar
  primaryColor: "#bb1ccc",
  secondaryColor: "#5e0768",
  // Sidebar background gradient colors (top to bottom)
  sidebarBackgroundColor: "#bb1ccc",
  sidebarBackgroundColorSecondary: "#5e0768",
  sidebarTextColor: "#FFFFFF",
  // Light hover/highlight color for sidebar menu items (non-active hover state)
  sidebarHighlightColor: "#6c246f",
  // Sidebar's own scrollbar thumb/track colors (side menu report list)
  sidebarScrollbarColor: "#bb1ccc",
  sidebarScrollbarColorSecondary: "#5e0768",
  sidebarScrollbarTrackColor: "transparent",


  // Hover background for the NavHeader user dropdown menu items (Access Management, etc.)
  headerMenuHoverColor: "#f8fafc",

  // Shared icons (sidebar + header menu icon)
  iconColor: "#bb1ccc",
  headerIconColor: "#bb1ccc",

  // User avatar initials + email text accent used in admin tables (UserManagement, UserTable)
  tableAccentColor: "#bb1ccc",
  tableAccentBackground: "#e0f2fe",
  tableAccentGradient: "linear-gradient(135deg, #bb1ccc, #5e0768)",

  // Button Styles
  buttonStyles: {
    primary: {
      backgroundColor: "#bb1ccc",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      transition: "all 0.3s",
      fontSize: "14px",
      fontWeight: "500",
    },
    secondary: {
      backgroundColor: "#fff",
      color: "#bb1ccc",
      border: "1px solid #bb1ccc",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      transition: "all 0.3s",
      fontSize: "14px",
      fontWeight: "500",
    },
    outline: {
      backgroundColor: "transparent",
      color: "#bb1ccc",
      border: "1.5px solid #bb1ccc",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      transition: "all 0.3s",
      fontSize: "14px",
      fontWeight: "500",
    },
  },

  // Shared primary button color
  buttonColor: "#bb1ccc",

  // Dialog header gradient
  dialogHeaderGradient: "linear-gradient(135deg, #bb1ccc, #5e0768)",

  // AI Data Assistant theme
  aiAssistantPrimaryColor: "#bb1ccc",
  aiAssistantSecondaryColor: "#5e0768",
  // Background of the question input box in the AI Data Assistant chat panel
  aiAssistantInputBackground: "#f8fafc",
  // Background of the input bar strip (behind the input box) in the AI Data Assistant chat panel
  aiAssistantInputBarBackground: "#f6edf6",

  // Analytics dashboard charts (Analtyics.jsx, LineChats.js, PieChats.js):
  // single-series color (KPI icons, bar/line charts) — matches the shared brand
  // icon color used across Department/Overview pages
  chartPrimaryColor: "#bb1ccc",
  // Multi-series palette (pie chart slices, multi-category legends)
  chartPalette: ["#bb1ccc", "#5e0768", "#0ea5e9", "#f59e0b", "#10b981", "#f43f5e", "#6366f1"],

  // Sidebar report-list letter box background colors — cycled per report by index
  sidebarReportColors: ["#1ba182", "#ac9e0e", "#0ea5e9", "#f59e0b", "#10b981", "#f43f5e", "#6366f1"],

  // Header branding
  // Set to imported asset from src. You can replace this import with another file.
  headerLogo: WaterMarkLogo,
  // Header logo layout controls
  // Accept number (treated as px) or CSS string (e.g. "220px", "1rem", "8px 12px")
  headerLogoWidth: 120,
  headerLogoHeight: "auto",
  headerLogoPadding: "0px 0px 0px 0px",
  headerLogoMargin: 0,
  headerLogoMarginLeft: 50,
  headerTitle: "Aays Insight Platform",
  // Text shown in place of/alongside the header logo (e.g. "Aays Insight Platform")
  headerBrandTextColor: "#bb1ccc",
  headerBrandTextMarginLeft: 16,

  // Favicon
  favicon: favicon,

  // Sidebar top logo — shown when collapsed (icon-only) vs expanded
  sidebarCollapsedLogo: sidebarCollapsedLogo,
  sidebarExpandedLogo: sidebarExpandedLogo,

  //title
  title: "Aays Insight Platform",
};

export const applyUiConfig = () => {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;
  root.style.setProperty(
    "--app-sidebar-bg",
    `linear-gradient(135deg, ${uiConfig.sidebarBackgroundColor || "#bb1ccc"}, ${
      uiConfig.sidebarBackgroundColorSecondary || uiConfig.sidebarBackgroundColor || "#bb1ccc"
    })`
  );
  root.style.setProperty("--app-sidebar-text", uiConfig.sidebarTextColor || "#FFFFFF");
  root.style.setProperty("--app-sidebar-highlight", uiConfig.sidebarHighlightColor || "#f3e8ff");
  root.style.setProperty(
    "--app-sidebar-scrollbar",
    `linear-gradient(180deg, ${
      uiConfig.sidebarScrollbarColorSecondary || uiConfig.sidebarScrollbarColor || "#bb1ccc"
    }, ${uiConfig.sidebarScrollbarColor || "#bb1ccc"})`
  );
  root.style.setProperty("--app-sidebar-scrollbar-track", uiConfig.sidebarScrollbarTrackColor || "transparent");
  root.style.setProperty("--app-header-menu-hover", uiConfig.headerMenuHoverColor || "#f8fafc");
  root.style.setProperty("--app-icon-color", uiConfig.iconColor || "#bb1ccc");
  root.style.setProperty("--app-primary-color", uiConfig.primaryColor || "#bb1ccc");
  root.style.setProperty("--app-header-icon-color", uiConfig.headerIconColor || "#bb1ccc");
  root.style.setProperty("--app-table-accent", uiConfig.tableAccentColor || "#bb1ccc");
  root.style.setProperty("--app-button-color", uiConfig.buttonColor || "#bb1ccc");
  
  // Apply button styles
  if (uiConfig.buttonStyles) {
    const primaryBtn = uiConfig.buttonStyles.primary || {};
    root.style.setProperty("--btn-primary-bg", primaryBtn.backgroundColor || "#bb1ccc");
    root.style.setProperty("--btn-primary-color", primaryBtn.color || "#fff");
    root.style.setProperty("--btn-primary-border", primaryBtn.border || "none");
    root.style.setProperty("--btn-primary-radius", primaryBtn.borderRadius || "6px");
    
    const secondaryBtn = uiConfig.buttonStyles.secondary || {};
    root.style.setProperty("--btn-secondary-bg", secondaryBtn.backgroundColor || "#fff");
    root.style.setProperty("--btn-secondary-color", secondaryBtn.color || uiConfig.buttonColor || "#bb1ccc");
    root.style.setProperty("--btn-secondary-border", secondaryBtn.border || `1px solid ${uiConfig.buttonColor || "#bb1ccc"}`);
    root.style.setProperty("--btn-secondary-radius", secondaryBtn.borderRadius || "6px");
    
    const outlineBtn = uiConfig.buttonStyles.outline || {};
    root.style.setProperty("--btn-outline-bg", outlineBtn.backgroundColor || "transparent");
    root.style.setProperty("--btn-outline-color", outlineBtn.color || uiConfig.buttonColor || "#bb1ccc");
    root.style.setProperty("--btn-outline-border", outlineBtn.border || `1.5px solid ${uiConfig.buttonColor || "#bb1ccc"}`);
    root.style.setProperty("--btn-outline-radius", outlineBtn.borderRadius || "6px");
  }
  
  root.style.setProperty(
    "--app-ai-assistant-primary",
    uiConfig.aiAssistantPrimaryColor || "#bb1ccc"
  );
  root.style.setProperty(
    "--app-ai-assistant-secondary",
    uiConfig.aiAssistantSecondaryColor || "#bb1ccc"
  );
  root.style.setProperty(
    "--app-ai-assistant-gradient",
    `linear-gradient(135deg, ${
      uiConfig.aiAssistantPrimaryColor || "#bb1ccc"
    }, ${uiConfig.aiAssistantSecondaryColor || "#bb1ccc"})`
  );
  root.style.setProperty(
    "--app-chart-primary",
    uiConfig.chartPrimaryColor
  );

  // Page title
  if (uiConfig.title) {
    document.title = uiConfig.title;
  }

  // Favicon
  if (uiConfig.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = uiConfig.favicon;
  }
};

export default uiConfig;
